import { Directive, effect, ElementRef, input } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[appAnimateOpen]',
  standalone: true,
})
export class AnimateOpenDirective {
  appAnimateOpen = input.required<boolean>();

  constructor(private readonly element: ElementRef) {
    element.nativeElement.style.transition = 'all 0.175s ease-in-out';
    element.nativeElement.style.overflow = 'hidden';
    effect(() => {
      if (this.appAnimateOpen()) {
        let innerContentHeight = 0;

        [...(element.nativeElement?.children || [])].forEach((value: any) => {
          const styles: Record<string, any> = window.getComputedStyle(value);

          let marginAndPaddingHeight = 0;
          ['marginTop', 'marginBottom'].forEach((key) => {
            marginAndPaddingHeight =
              marginAndPaddingHeight + parseFloat(styles[key] || 0);
          });

          innerContentHeight +=
            value.getBoundingClientRect()?.height + marginAndPaddingHeight;
        });

        element.nativeElement.style.height = `${innerContentHeight}px`;
      } else {
        element.nativeElement.style.height = '0px';
      }
    });
  }
}
